import './App.scss';
import {Component} from 'react';
import Editor from './components/Editor.js';
import CheckList from './components/CheckList.js';
import Settings from './components/Settings';
import InfoBar from './components/InfoBar';
import LocalStorage from './lib/LocalStorage.js';
import Markup from './lib/Markup.js';
import Fetch from './lib/Fetch.js';
import { initHeaderForm } from './Header.js';
import Description from './components/Description.js';

class App extends Component {
	constructor(props) {
		super(props);
		let content = LocalStorage.getItem('editor-content') || '';
		let aiModel = this.getSetting('aiModel');
		if (aiModel) {
			if (aiModel === 'gpt-4-turbo') {
				aiModel = 'gpt-4.1';
			}
			if (aiModel.includes('3.5')) {
				aiModel = 'gpt-4.1-mini';
			}
		}
		this.state = {
			loggedIn: false,
			content: Markup.removeEmptyLines(content).replaceAll('&nbsp;', ' '),
			siteUrl: '',
			settingsShown: false,
			settings: {
				maxWordsPerSentence: parseInt(this.getSetting('maxWordsPerSentence')) || 20,
				maxSentencesPerParagraph: parseInt(this.getSetting('maxSentencesPerParagraph')) || 5,
				maxWordsPerParagraph: parseInt(this.getSetting('maxWordsPerParagraph')) || 100,
				maxParagraphsPerHeading: parseInt(this.getSetting('maxParagraphsPerHeading')) || 3,
				maxWordsInIntro: parseInt(this.getSetting('maxWordsInIntro')) || 30,
				minKeywordDensity: this.getSetting('minKeywordDensity') || '',
				maxKeywordDensity: this.getSetting('maxKeywordDensity') || '',
				minContentLength: this.getSetting('minContentLength') || '',
				maxContentLength: this.getSetting('maxContentLength') || '',
				disallowedWords: this.getSetting('disallowedWords') || '',
				language: this.getSetting('language') || 'en',
				location: this.getSetting('location') || 'United States',
				keywordSrc: this.getSetting('keywordSrc') || 'tfidf',
				aiModel: aiModel  || 'gpt-4.1-mini',
				outlineAiModel: this.getSetting('outlineAiModel') || 'gpt-4.1-mini',
			},
			user: {},
			limitUsage: {
				daily: {
					'article-generator': 0,
				},
				monthly: {
					'article-generator': 0,
				},
				permanent: {
					'article-generator': 0,
				}
			},
			limits: {
				daily: {
					'article-generator': 0,
				},
				monthly: {
					'article-generator': 0,
				},
				permanent: {
					'article-generator': 0,
				}
			},
			permissions: [],
			score: 0,
			descriptionShown: false,

		};
		this.saveContent = this.saveContent.bind(this);
		this.saveUrl = this.saveUrl.bind(this);
		this.toggleSettings = this.toggleSettings.bind(this);
		this.handleSettingsChange = this.handleSettingsChange.bind(this);
		this.saveScore = this.saveScore.bind(this);
		this.updateLimitUsage = this.updateLimitUsage.bind(this);
	}

	saveContent(content) {
		if (content !== this.state.content) {
			if (!Markup.stripTags(content).trim()) {
				content = '';
			}
			this.setState({content: content});
			content = Markup.removeEmptyLines(content).replaceAll('&nbsp;', ' ').replaceAll('<mark>', '').replaceAll('</mark>', '');
			if (content) {
				LocalStorage.setItem('editor-content', content);
			} else {
				LocalStorage.removeItem('editor-content');
			}
		}
	}

	saveScore(value) {
		let text = Markup.stripTags(this.state.content);
		this.setState({score: text ? value : 0});
	}

	async componentDidMount() {
		initHeaderForm();

		const slug = window.slug;
		const urlParams = new URLSearchParams(window.location.search);
		const forceFree = urlParams.get('free') || false;

		const payload = {};
		if (forceFree) {
			payload.free = true;
		}

		const data = await Fetch.post(`https://${window.location.hostname}/tools/${slug}/ajax/session.php`, payload);

		if (!data) {
			return;
		}

		const limits = {
			daily: {},
			monthly: {},
			permanent: {},
		};

		let limitList = ['article-generator', 'content-editor-ai-internal-links', 'content-related-keywords'];
		if (data.planData && data.planData.limits) {
			limitList.forEach((name) => {
				limits.daily[name] = data.planData.limits.daily ? data.planData.limits.daily[name] || 0 : 0;
				limits.monthly[name] = data.planData.limits.monthly ? data.planData.limits.monthly[name] || 0 : 0;
				limits.permanent[name] = data.planData.limits.permanent ? data.planData.limits.permanent[name] || 0 : 0;
			});
		}

		let newState = {
			loggedIn: !!data.loggedIn,
			user: data.user,
			limits: limits,
			limitUsage: {
				daily: {
					'article-generator': data.limitUsage ? data.limitUsage.daily.articleGenerator || 0 : 0,
					'content-editor-ai-internal-links': data.limitUsage ? data.limitUsage.daily.linkSuggestions || 0 : 0,
					'content-related-keywords': data.limitUsage ? data.limitUsage.daily.relatedKeywords || 0 : 0,
				},
				monthly: {
					'article-generator': data.limitUsage ? data.limitUsage.monthly.articleGenerator || 0 : 0,
					'content-editor-ai-internal-links': data.limitUsage ? data.limitUsage.monthly.linkSuggestions || 0 : 0,
					'content-related-keywords': data.limitUsage ? data.limitUsage.monthly.relatedKeywords || 0 : 0,
				},
				permanent: {
					'article-generator': data.limitUsage ? data.limitUsage.permanent.articleGenerator || 0 : 0,
					'content-editor-ai-internal-links': data.limitUsage ? data.limitUsage.permanent.linkSuggestions || 0 : 0,
					'content-related-keywords': data.limitUsage ? data.limitUsage.permanent.relatedKeywords || 0 : 0,
				}
			}
		}

		if (data.planData.permissions) {
			newState.permissions = data.planData.permissions.filter((perm) => perm.includes('content-'));
		}

		this.setState(newState);
	}

	saveUrl(url) {
		this.setState({siteUrl: url});
	}

	toggleSettings() {
		let value = !this.state.settingsShown;
		this.setState({settingsShown: value});
	}

	getSetting(name) {
		return LocalStorage.getItem('seotools-' + name);
	}

	handleSettingsChange(name, value) {
		LocalStorage.setItem('seotools-' + name, value);
		let settingsObject = this.state.settings;
		settingsObject[name] = value;
		this.setState(settingsObject);
	}

	render() {
		const isPro = this.state.loggedIn && this.state.user.plan !== 'free';
		const settingsPopup = this.state.settingsShown ? (<div className="overlay"><Settings
			settings={this.state.settings}
			changeCallback={this.handleSettingsChange}
			closeCallback={this.toggleSettings}
			permissions={this.state.permissions}
			isPro={isPro}
		/></div>) : '';
		const descriptionPopup = this.state.descriptionShown ? (
			<div className="overlay">
				<Description closeCallback={this.toggleDescription}></Description>
			</div>
		) : '';
		return (
			<div className="App">
				<Editor
					contentCallback={this.saveContent}
					urlCallback={this.saveUrl}
					content={this.state.content}
				/>
				<InfoBar
					content={this.state.content}
					appSettings={this.state.settings}
					isPro={isPro}
					score={this.state.score}
					toggleSettingsCallback={this.toggleSettings}
				/>
				<CheckList
					content={this.state.content}
					contentCallback={this.saveContent}
					appSettings={this.state.settings}
					isPro={isPro}
					scoreCallback={this.saveScore}
					language={this.state.settings.language}
					limits={this.state.limits}
					limitUsage={this.state.limitUsage}
					limitUsageCallback={this.updateLimitUsage}
					permissions={this.state.permissions}
					toggleSettingsCallback={this.toggleSettings}
				/>
				{settingsPopup}
			</div>
		);
	}

	async updateLimitUsage(limitName, price = '') {
		const limits = [];
		const newState = {};

		if (typeof this.state.limits.daily[limitName] !== 'undefined') {
			limits.push('daily-' + limitName);
		}
		if (typeof this.state.limits.monthly[limitName] !== 'undefined') {
			limits.push('monthly-' + limitName);
		}
		if (this.state.limits.permanent && typeof this.state.limits.permanent[limitName] !== 'undefined') {
			limits.push('permanent-' + limitName);
		}

		if (!limits.length) {
			return true;
		}

		const done = await Fetch.post(`https://${window.location.hostname}/tools/content/ajax/update-limit-usage.php`, {
			uid: this.state.user ? this.state.user.id : false,
			limits: limits,
			price: price,
		});

		if (done.status === 'ok') {
			if (done.credits || done.credits === 0) {
				let newUser = this.state.user;
				newUser.credits = done.credits;
				newState.user = newUser;
			}

			if (done.limitUsage) {
				let newLimitUsage = {
					daily: {},
					monthly: {},
					permanent: {},
				};
				if (this.state.limits.daily[limitName] && done.limitUsage[`daily-${limitName}`]) {
					newLimitUsage.daily[limitName] = done.limitUsage[`daily-${limitName}`];
				}
				if (this.state.limits.monthly[limitName] && done.limitUsage[`monthly-${limitName}`]) {
					newLimitUsage.monthly[limitName] = done.limitUsage[`monthly-${limitName}`];
				}
				if (this.state.limits.permanent[limitName] && done.limitUsage[`permanent-${limitName}`]) {
					newLimitUsage.permanent[limitName] = done.limitUsage[`permanent-${limitName}`];
				}
				newState.limitUsage = newLimitUsage;
			}
		}

		this.setState(newState);

		return done.status === 'ok';
	}
}

export default App;
